
import React from 'react';
import { Image } from '@themesberg/react-bootstrap';
import Logo2 from '../assets/img/brand/logo2.png'

import ReactLogo from "../assets/img/technologies/react-logo-transparent.svg";

export default (props) => {

  const { show } = props;

  return (
    <div className={`preloader bg-soft flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
      <Image className="loader-element animate__animated animate__jackInTheBox" src={Logo2} height={40} />
    </div>
  );
};
